import React, { useEffect, useState } from "react"

export function useVideoThumbnail(ref: React.RefObject<HTMLVideoElement>, url: string) {
  /* Thumbnail */
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!ref || !ref.current) {
      return
    }
  }, [url])

  useEffect(() => {
    if (!ref || !ref.current) {
      return
    }

    if (ref.current.currentTime || ref.current.currentTime < 15) {
      ref.current.currentTime = 40
      setIsLoading(false)
    }
  }, [isLoading])

  return { isLoading, setIsLoading }
}
